import { createI18n } from "vue-i18n";
import Cookies from "js-cookie";
import enLocale from "./en-US.json";
import deLocale from "./de-DE.json";

const messages = {
  en: enLocale,
  de: deLocale,
};

export function getLanguage(): string {
  let lang = Cookies.get("language");
  if (!lang) {
    lang = "de";
  }
  return lang;
}

export function setLanguage(lang: string) {
  i18n.global.locale.value = lang as "en" | "de";
  Cookies.set("language", lang, {
    expires: 365,
    sameSite: "strict",
    secure: true,
  });
}

export function getLanguageIso(): string {
  switch (getLanguage()) {
    case "en":
      return "en_US";
    default:
      return "de_DE";
  }
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  globalInjection: true, // Enable $t in templates
  locale: getLanguage(),
  fallbackLocale: "de",
  messages,
});

// Backwards compatibility helper for code using i18n.t() directly
// In Vue 3 with vue-i18n, use i18n.global.t() instead
export const t = (key: string, ...args: any[]) => (i18n.global.t as any)(key, ...args);

export default i18n;
